import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { SaveButton } from 'modules/finance/components/CostCenterAssigments/Assigments/ManageAssignments/components/SaveButton'
import { useCostCentersMutations } from 'modules/finance/hooks/useCostCentersMutations'
import { FormattedAssignment } from 'modules/finance/lib/costCenterAssignments'

interface Props {
  assignments: FormattedAssignment[]
  disabled: boolean
  resourceId: number
  onSave?: () => void
}

export const CreateButton = ({ assignments, disabled, resourceId, onSave }: Props) => {
  const { company } = useCurrentSession()
  const { create } = useCostCentersMutations()

  const handleOnClick = async () => {
    const successSave = await create({
      assignments: assignments.map((assignment) => ({
        companyId: company.id,
        employeeId: resourceId,
        costCenterId: Number(assignment.costCenterId),
        percentage: assignment.percentage,
        startDate: assignment.startDate,
        endDate: assignment.endDate === '' ? undefined : assignment.endDate,
      })),
    })

    if (successSave) {
      track(trackingEvents.accounting.saveCostCenterAssignment, {
        source: 'new_assignment',
      })

      onSave?.()
    }
  }

  return (
    <SaveButton
      disabled={disabled}
      label={i18n.t('finance.cost_centers.assignments.create.button')}
      onSave={handleOnClick}
    />
  )
}
